import { ORIENTATION_TOUR_ID } from '@/core/guidance/constants';

type KeyValueStorage = Pick<Storage, 'getItem' | 'setItem'>;

/**
 * TourKit stores completion under `guidance:<userId>:tourkit:<userId>:completed`
 * (adapter prefix + persistence keyPrefix). The welcome tour is once per user,
 * not once per workspace.
 */
export function orientationTourRecordKey(
  userId: string,
  bucket: 'completed' | 'skipped' | 'seen',
): string {
  return `guidance:${userId}:tourkit:${userId}:${bucket}`;
}

function listIncludesTour(raw: string | null): boolean {
  if (!raw) return false;
  try {
    const parsed: unknown = JSON.parse(raw);
    return (
      Array.isArray(parsed) &&
      parsed.some((entry) => entry === ORIENTATION_TOUR_ID)
    );
  } catch {
    return false;
  }
}

export function hasSeenOrientationTour(
  userId: string | undefined,
  storage: KeyValueStorage | null,
): boolean {
  if (!userId || !storage) return false;
  if (storage.getItem(orientationTourRecordKey(userId, 'seen')) === '1') {
    return true;
  }
  return (
    listIncludesTour(
      storage.getItem(orientationTourRecordKey(userId, 'completed')),
    ) ||
    listIncludesTour(
      storage.getItem(orientationTourRecordKey(userId, 'skipped')),
    )
  );
}

export function markOrientationTourSeen(
  userId: string | undefined,
  storage: KeyValueStorage | null,
): void {
  if (!userId || !storage) return;
  try {
    storage.setItem(orientationTourRecordKey(userId, 'seen'), '1');
  } catch {
    // Quota or private mode: the in-memory tour still runs this visit.
  }
}

export function browserOrientationStorage(): KeyValueStorage | null {
  if (typeof localStorage === 'undefined') return null;
  return localStorage;
}
